var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "live-assistant-buttons" }, [
    _c("div", { staticClass: "button-group" }, [
      _c(
        "button",
        {
          staticClass: "function-btn",
          attrs: { disabled: _vm.disabled },
          on: { click: _vm.handleFunction2 },
        },
        [
          _c("img", {
            staticClass: "btn-icon",
            attrs: {
              src: require("@/assets/image/aigc/aiagent/icn_fenxi.png"),
              alt: "查询",
            },
          }),
          _vm._v(" 直播间数据 "),
        ]
      ),
      _c(
        "button",
        {
          staticClass: "function-btn",
          attrs: { disabled: _vm.disabled },
          on: { click: _vm.handleFunction3 },
        },
        [
          _c("img", {
            staticClass: "btn-icon",
            attrs: {
              src: require("@/assets/image/aigc/aiagent/icn_ppt.png"),
              alt: "分析",
            },
          }),
          _vm._v(" 到课率 "),
        ]
      ),
      _c(
        "button",
        {
          staticClass: "function-btn",
          attrs: { disabled: _vm.disabled },
          on: { click: _vm.handleFunction5 },
        },
        [
          _c("img", {
            staticClass: "btn-icon",
            attrs: {
              src: require("@/assets/image/aigc/aiagent/icn_money.png"),
              alt: "营收",
            },
          }),
          _vm._v(" IP班期营收表 "),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }